/**
 * Remembers what just asked the Employee Computer to open, so the shell's mount can report HOW it appeared
 * (`computer_shown`, TRACKING.md; Nitish, Sep 26 2026). Callers mark 'click' / 'phone_teaser' / 'deep_link';
 * no mark means the saved "open" preference opened it by itself ('default'). A mark older than 5 seconds is
 * ignored, so an ask that did not mount a new shell never leaks into a later appearance.
 */
let mark = null;

export const markComputerOpen = (source) => {
  mark = { source, at: Date.now() };
};

export const takeComputerOpenSource = () => {
  const m = mark;
  mark = null;
  return m && Date.now() - m.at < 5000 ? m.source : 'default';
};
